export default [
  {
    path: "/unidadesNegocio",
    component: () => import("@/views/unidadesNegocio/Listar.vue"),
  },
  {
    path: "/unidadesNegocio/crear",
    component: () => import("@/views/unidadesNegocio/Crear.vue"),
  },
  {
    path: "/unidadesNegocio/editar/:id",
    component: () => import("@/views/unidadesNegocio/Editar.vue"),
  },
];
